import { Box, Card, CardContent, Grid, Typography, Button, Dialog, DialogContent, Slide, AppBar, Toolbar, IconButton } from '@mui/material';
import React from 'react';
import DataWhisperFeed from './Customer/DataWhisperFeed';
import KeyData from './Customer/Common/KeyData';
import CustomerBriefing from './Customer/Common/CustomerBriefing';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import PerformanceReview from './Customer/PerformanceReview';
import { TransitionProps } from '@mui/material/transitions';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Customers() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const [biggest_opportunities, setBiggestOpportunities] = React.useState(JSON.parse(localStorage.getItem('biggest_opportunities') || '{}'));
    const [customer_briefing, setCustomerBriefing] = React.useState(JSON.parse(localStorage.getItem('customer_briefing') || '{}'));
    const [customer_key_data, setCustomerKeyData] = React.useState(JSON.parse(localStorage.getItem('customer_key_data') || '{}'));
    const [customer_index, setCustomerIndex] = React.useState(localStorage.getItem('customer_index') || '{}');
    const [customer_name, setCustomerName] = React.useState(localStorage.getItem('customer_name') || '{}');
    const [customer_id, setCustomerId] = React.useState(localStorage.getItem('customer_id') || '{}');
    const [entity_id, setEntityId] = React.useState(localStorage.getItem('entity_id') || '{}');
    const [mode, setMode] = React.useState(localStorage.getItem('theme') || '{}');
    const [cust_group_1, setCustGroup1] = React.useState(localStorage.getItem('cust_group_1') || '{}');
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Box sx={{ width: '100%', height: '100%'}}>
                <Box sx={{ display: 'flex', mb: 4, justifyContent: 'flex-end' }}>
                    <Box sx={{ display: 'flex', gap: 1, float: 'right' }}>
                        <Button 
                            href={user.role === 'Administrator' ? `/admin/customers/${customer_id}/items-purchased?entity_id=${entity_id}` : user.role === 'Executive' ? `/executive/customers/${customer_id}/items-purchased?entity_id=${entity_id}` : `/customers/${customer_id}/items-purchased?entity_id=${entity_id}`} 
                            variant="contained" 
                            size="small" 
                            color="primary" 
                            style={{ textTransform: 'capitalize', boxShadow: 'none' }}
                        >
                            Go to Items Purchased
                        </Button>
                    </Box>
                </Box>
                <Grid container spacing={2} sx ={{ sm: 2, md: 3 }} >
                    <Grid 
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 5 }}
                        sx={{ borderRadius: '6px !important', border: '1px solid #f0f0f0 !important'}}
                    >
                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', borderRadius: '6px !important', typography: 'body1', height: '100%', gap: 1, backgroundColor: 'white' }}>
                            <KeyData customer_key_data={customer_key_data} name={customer_name as string} cust_group_1={cust_group_1 as string} />
                            <CustomerBriefing customer_briefing={customer_briefing} />
                        </Box>
                    </Grid>
                    <Grid 
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }} 
                        sx={{ 
                            borderRadius: '6px !important', 
                            backgroundColor: 'white',
                            border: '1px solid #f0f0f0 !important',
                            height: 'auto'
                        }}
                    >
                        <Card sx={{
                            boxShadow: 'none',
                            borderRadius: '6px !important',
                            bgcolor: 'white',
                            border: 0
                        }}>
                            <CardContent sx={{ padding: 0 }}>
                                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', typography: 'body1', height: '100%'}}>
                                    <Box sx={{ width: '100%', height: 'auto', flex :'row', padding: 2, alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Typography variant="h6" sx={{ margin: 0, padding: 0, fontSize: 'clamp(0.9rem, 3vw, 1.1rem) !important;' }}>
                                            Performance Review
                                            <Button variant="text" startIcon={<FullscreenIcon fontSize="small" />} color="primary" style={{ textTransform: 'capitalize', float: 'right' }} onClick={handleOpen}>Maximize</Button>
                                        </Typography>
                                    </Box>
                                    <PerformanceReview customer_id={Number(customer_id)} height={500} />
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid 
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} 
                        sx={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            borderRadius: '6px !important', 
                            backgroundColor: 'white',
                            height: 'auto',
                            border: '1px solid #f0f0f0 !important'}}
                    >
                        <DataWhisperFeed customer_index={customer_index} customer_id={Number(customer_id)} mode={mode} biggest_opportunities={biggest_opportunities} />
                    </Grid>
                </Grid>
            </Box>
            <Dialog fullScreen open={open} TransitionComponent={Transition} onClose={handleClose}>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Performance Review</Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <PerformanceReview customer_id={Number(customer_id)} height={window.innerHeight - 300} />
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}